import React from 'react';

function Sms() {
  return (
    <div>
      <svg
        width='80'
        height='80'
        viewBox='0 0 80 80'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g filter='url(#filter0_i_115_358)'>
          <rect width='80' height='80' rx='40' fill='currentColor' />
          <path
            d='M53.5801 40.1013V59.0014L47.5476 53.7513H42.7205V45.3513H47.5476L53.5801 40.1013ZM55.3887 20.9986C55.8687 20.9986 56.3798 21.2296 56.7192 21.6235C57.0587 22.0173 57.2 22.3314 57.2 22.8884L57.2305 37.0497H55.6615L55.631 24.6235L39.2111 37.0497L22.8113 24.5877V51.8263H39.2111V53.7513H22.8113C22.3313 53.7513 21.8709 53.5301 21.5315 53.1363C21.192 52.7424 21.0013 52.3833 21.0013 51.8263V22.8884C21.0013 22.3314 20.9497 21.9606 21.2891 21.5668C21.6286 21.1729 22.0889 20.9986 22.5689 20.9986H55.3887ZM55.39 45.3513C56.3251 45.3539 57.223 45.7761 57.8957 46.5297C58.5684 47.2832 58.9637 48.3095 58.9988 49.3937C59.0339 50.4778 58.706 51.5357 58.0839 52.3456C57.4619 53.1556 56.5938 53.6548 55.6615 53.7387L55.39 53.7513V45.3513ZM55.631 22.8884H22.8113L39.2111 34.7839L55.631 22.8884Z'
            fill='#FEFEFE'
          />
        </g>
        <defs>
          <filter
            id='filter0_i_115_358'
            x='-4.42632'
            y='-0.737721'
            width='84.4263'
            height='80.7377'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='BackgroundImageFix'
              result='shape'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dx='-4.42632' dy='-0.737721' />
            <feGaussianBlur stdDeviation='2.21316' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.564706 0 0 0 0 0.564706 0 0 0 0 0.866667 0 0 0 1 0'
            />
            <feBlend
              mode='normal'
              in2='shape'
              result='effect1_innerShadow_115_358'
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
}

export default Sms;
